import { admin as actions } from '../actions'

export const reducer = {}

reducer[actions.UPDATE_TX_LOG] = ({ state, action }) => {
  return {
    ...state,
    txLog: action.updateFn(state.txLog)
  }
}
